import React from 'react';
import { useLocation } from 'react-router-dom';
import RecoveryNotice from './RecoveryNotice';
import AsyncFailureNotice from './AsyncFailureNotice';

export class PageErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { failed: false, resetKey: props.resetKey }; }
  static getDerivedStateFromError() { return { failed: true }; }
  static getDerivedStateFromProps(props, state) {
    return props.resetKey !== state.resetKey ? { failed: false, resetKey: props.resetKey } : null;
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <RecoveryNotice
      message="Something went wrong while displaying this page. Try opening it again. An action you already submitted may still have completed; check its saved status before submitting it again."
      onRetry={() => this.setState({ failed: false })} />;
  }
}

// Changing routes can recover a failed view without reloading the browser.
// Retrying the same URL remounts the view; it never replays a submitted request.
export default function RouteErrorBoundary({ children }) {
  const location = useLocation();
  return <><AsyncFailureNotice /><PageErrorBoundary resetKey={location.pathname + location.search}>{children}</PageErrorBoundary></>;
}
